import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class MobileUsersService {
  constructor(private http: HttpClient) {}

  public fetchMobileUsers(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/mobileUser/list`
    return this.http.post(url, params)
  }
  public fetchMobileUser(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/mobileUser/${id}`
    return this.http.get(url, {})
  }

  public deleteMobileUser(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/mobileUser/${id}`
    return this.http.delete(url)
  }

  public createMobileUser(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/mobileUser`
    return this.http.post(url, params)
  }

  public updateMobileUser(id: number, params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/mobileUser/${id}`
    return this.http.put(url, params)
  }

  public reissueActivationCode(userId: any): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/mobileUser/${userId}/reissueActivationCode`
    return this.http.get(url, {})
  }
}
